import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// MUI
import { Box, Skeleton } from "@mui/material";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Components
import { useWindowSize } from "../../../utils/useWindowSize";
import { briefInfoType } from "../../../interface/MainInterface";
import { HttpUnAuthApi } from "../../../interface/unauth-api";

// CSS
import "./TopBanner.css";
import "swiper/css";
import dayjs from "dayjs";

interface propsType {
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const TopBanner = (props: propsType) => {
  const windowSize = useWindowSize();
  const navigate = useNavigate();
  const slideRef: any = useRef();

  const [issueList, setIssueList] = useState<briefInfoType[]>([]);

  useEffect(() => {
    const get_issue_list = async () => {
      const param: any = {
        command: "get_brief_list_with_key",
        limit: 5,
      };

      const from_dtm = dayjs().subtract(3, "day").format("YYYYMMDD");
      const to_dtm = dayjs().add(1, "day").format("YYYYMMDD");

      param.from_dtm = from_dtm;
      param.to_dtm = to_dtm;

      const res = await unAuthAPI.post(param);
      if (res.code === "200") {
        let temp: any = [];
        for (const brief of res.response.brief_list) {
          if (temp.length > 5) break;
          if (brief.ai_title === undefined || brief.ai_title === null || brief.ai_title === "" || brief.show_pk === "IT") {
            continue;
          } else {
            temp.push(brief);
          }
        }
        setIssueList([...temp, ...temp]);
      } else {
        console.error("[ERROR] get_issue_list : ", res.response.error_msg);
      }
    };
    get_issue_list();
    return () => {
      setIssueList([]);
    };
  }, []);

  // Swiper navigate
  const handleSlidePrev = () => {
    if (!slideRef.current) return;
    slideRef.current.swiper.slidePrev();
  };
  const handleSlideNext = () => {
    if (!slideRef.current) return;
    slideRef.current.swiper.slideNext();
  };

  return (
    <>
      <article className="article-01">
        <div className="article-tit">
          오늘의 <span className="highlighter">HOT</span> 트렌드
          <img src="/images/icon-fire.png" alt="" />
          <br />
          AI Trend Brief로 신속하게 파악하세요
        </div>
        {issueList.length > 0 ? (
          <>
            <Box sx={{ position: "absolute", left: 0, right: 0 }}>
              <div className="main-slide-wrap">
                <div className="swiper_center">
                  <Swiper
                    ref={slideRef}
                    slidesPerView={"auto"}
                    centeredSlides={true}
                    loop
                    spaceBetween={windowSize.width > 1023 ? 25 : 12}
                    navigation={{
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    }}
                    autoplay={{
                      delay: 4000,
                      disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                    className="swiper-wrapper"
                  >
                    {issueList.map((data: briefInfoType, index: number) => (
                      <SwiperSlide
                        key={`main-slide-${index}`}
                        className="swiper-slide aitb-swiper-slide"
                        onClick={() => {
                          navigate(`/brief/${data.show_pk}/${data.sk}`);
                        }}
                        style={{ border: "1px solid #efefef", boxSizing: "border-box" }}
                      >
                        <img src={data.image_list[0]} alt="" loading="lazy"/>
                        <div className="brife-info-wrap white-space-pre-line">
                          <dl>
                            <dt className="top-banner-title">{data.ai_title}</dt>
                            <dd>
                              <button>View this brief →</button>
                            </dd>
                          </dl>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </Box>
            <div className="main-slide-btn-wrap">
              <div className="swiper-button-prev" onClick={handleSlidePrev}>
                <img src="/images/icon-arr-prev.png" alt="" />
              </div>
              <div className="swiper-button-next" onClick={handleSlideNext}>
                <img src="/images/icon-arr-next.png" alt="" />
              </div>
            </div>
          </>
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={"320px"} sx={{ borderRadius: "30px" }} />
        )}
        <Box sx={{ height: windowSize.width > 1023 ? "0px" : "64px" }}></Box>
      </article>
    </>
  );
};

export default TopBanner;
